// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import PriceLabel from "../images/pricelabel.svg"
import QtyLabel from "../images/qtylabel.svg"
import crossIcon from "../images/Incorrect.svg"
import CorrectIcon from "../images/CorrectIcon.svg"
import DraggableLabel from "./DraggableLabel";
import DropableLabel from "./DropableLabel";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";
import "animate.css/animate.css";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
var CanvasJS = CanvasJSReact.CanvasJS;

const questions = [
  {
    id: 1,
    title: "ABC",
    step: 5,
    row: 12,
    col: 10,
    ymax: 63,
    xmax: 53,
    answer: [{x: 50, y: 5}, {x: 25, y: 20}, {x: 5, y: 55}]
  },
  {
    id: 2,
    title: "DEF",
    step: 100,
    row: 10,
    col: 10,
    ymax: 1000,
    xmax: 1000,
    answer: [{x: 100, y: 100}, {x: 200, y: 900}, {x: 500, y: 600}]
  },
];

const BubbleAndLine = (props) => {
  const [reRender, setReRender] =useState(0)
  const [answerCoordinates, setAnswerCoordinates] =useState([{style: {}, XYPoint: {}}])
  const [correctCount, setCorrectCount] =useState(0)
  const [allCorrect, setAllCorrect] =useState(true)
  const [inPrice, setInPrice] =useState(false)
  const [inQuality, setInQuality] =useState(false)
  const [xLabel, setXLabel] =useState("")
  const [yLabel, setYLabel] =useState("")
  const [draggableLabel, setDraggableLabel] =useState("")
  const [draggedLabels, setDraggedLabels] =useState([])
  const { qIndex, handleReloadClick, classes } = props;

  const my_w = Array.from({ length: questions[qIndex].col }, (_, row) => {
    // console.log("row", row)
    let dd = Array.from({ length: questions[qIndex].row }, (_, col) => ({
      x: (row+1)*questions[qIndex].step,
      y: (col+1)*questions[qIndex].step,
      cursor: "pointer",
      z: 3
    }))
    return dd
  })

  const priceRef = useRef(null);
  const qualityRef = useRef(null);

  // console.log("mydd_w", my_w)
  const [chartData, setChartData] =useState([])
  const [bubbleData, setBubbleData] =useState([])
  const [bubbleColor, setSubbleColor] =useState('#003e4c')
  const [lineData, setLineData] =useState([])
  const [submit, setSubmit] =useState(false)
  const correctAnswers = questions[qIndex].answer

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "scatter",
      color: 'transparent',
      markerSize: isMobile ? 18 : 25,
      click: (event, elements) => {
        if(!submit){
          // x change: 45 = > 45/5 =>9 so 1 chart point on x is 9px
          // y change 24 => 24/5 => 4.7 so 1 chart point on y is 4.5px
          // base 0f x is 26
          // base 0f y is 66
          // margin form left = 30
          // margin form top = 10
          let obj = event.dataPoint
          let correct_or_not = isCorrectAnswer(obj)
          let tmpAns = answerCoordinates
          let pointObj = {
            style: {
              // left: (event.dataPoint.x * 7.8) + 30 + 20,
              // top: ((60 - event.dataPoint.y) * 4.85) + 66 - 25,
              top: event.chart.axisY[0].convertValueToPixel(event.dataPoint.y) - 30,
              left: event.chart.axisX[0].convertValueToPixel(event.dataPoint.x),
              position: 'absolute',
              fontSize: isMobile ? 12 : 16,
              zIndex: 100,
              fontWeight: 700,
              color: correct_or_not ? '#008002' : '#fe0000'},
              XYPoint: {x: obj.x, y: obj.y}
          }
          let tempdata = data
          let existingIndex = tempdata[2].dataPoints.findIndex((dataPoint) =>
            dataPoint.x === obj.x &&
            dataPoint.y === obj.y
          );

          let pointExistingIndex = tmpAns.findIndex((dataPoint) =>
            dataPoint.XYPoint.x === obj.x &&
            dataPoint.XYPoint.y === obj.y
          );

          if (existingIndex === -1) {
            // If the object is not found, push it to the array
            tempdata[2].dataPoints.push(obj);
            tmpAns.push(pointObj)
          } else {
            // If the object is found, remove it from the array
            tempdata[2].dataPoints.splice(existingIndex, 1);
            tmpAns.splice(pointExistingIndex, 1)
          }

          // tempdata[2].dataPoints.push(obj)
          setAnswerCoordinates(tmpAns)
          setChartData(tempdata)
          setReRender(Math.random())
        }
      },
      dataPoints: [].concat.apply([], my_w)
    },
    {
      type: "scatter",
      markerSize: isMobile ? 14 : 20,
      color: bubbleColor,
      dataPoints: bubbleData
    },
    {
      type: "spline",
      color: 'green',
      lineThickness: isMobile ? 3 : 5 ,
      dataPoints: lineData
    },
  ]

  const isCorrectAnswer = (ans) => {
    let isCorrect = false
    correctAnswers.map((correctAnswer) => {
      if(correctAnswer.x === ans.x && correctAnswer.y === ans.y){
        isCorrect = true
      }
    })
    return isCorrect
  }

  const isAllAnswerisCorrect = () => {
    let tempAllCorrect = true
    let temp = false
    let tempCount = 0
    correctAnswers.map((correctAnswer) => {
      temp = false
      data[2].dataPoints.map((point) => {
        if(correctAnswer.x === point.x && correctAnswer.y === point.y){
          temp = true
        }
      })
      tempAllCorrect = tempAllCorrect && temp
      if(temp){
        tempCount = tempCount + 1
        setCorrectCount(tempCount)
      }
    })
    setAllCorrect(tempAllCorrect)
    return tempAllCorrect
  }

  useEffect(() => {
    setChartData(data)
  }, [])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: "Demand for Oil",
      fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: isMobile ? 14 : 24,
      padding: {
        top: 10,
        bottom: 0,
      },
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questions[qIndex].step,
      minimum: 0,
      maximum: questions[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questions[qIndex].step,
      minimum: 0,
      maximum: questions[qIndex].ymax,
      margin: 10
      // title: " asdas",
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile ? 250 : 400,
   width: isMobile ? 320 : 500
  }

  useEffect(() => {
    if(submit === true){
      if(isAllAnswerisCorrect()){
        setLineData(bubbleData)
        data[3].dataPoints = bubbleData
        data[2].color = "#008002"

      }else{
        data[2].dataPoints = data[2].dataPoints.map((point) => {
          if(isCorrectAnswer(point)){
            point.color = "#008002"
          }else{
            point.color = "#fe0000"
          }
          return point
        })
        // data[3].dataPoints = bubbleData
      }
      setChartData(data)
    }
  },[submit])

  function getLabeltext() {
    if((yLabel === "" && xLabel === "")){
      return "You forgot to place the Price and Quantity labels."
    }
    else if((yLabel === "" || xLabel === "")){
      return "You forgot to place a label."
    }
    else if((xLabel === "PRICE" && yLabel !== "QUANTITY") || (xLabel !== "PRICE" && yLabel === "QUANTITY")){
      return "you placed a label incorrectly"
    }
    else if(xLabel !== "PRICE" && yLabel !== "QUANTITY"){
      return "You placed both labels incorrectly."
    }
  }

  function getAnswertext() {
    let dots = answerCoordinates.length - 1
    if(dots === 0){
      return "You forgot to place the dots on the Demand Curve graph."
    }
    else if(dots < 3){
      return "You didn't place all the dots."
    }
    else if(dots >= 3 && !allCorrect){
      return "You placed the dots incorrectly."
    }
  }

  function getButtonText() {
    if(submit){
      // return allCorrect ? "Next" : "Try Again"
      return allCorrect && (xLabel === "PRICE" && yLabel === "QUANTITY") ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const onDragEnd = () => {
    // setDragState();

    if (!inPrice && !inQuality) return;

    if (inPrice) {
      setXLabel(draggableLabel)
    } else if (inQuality) {
      setYLabel(draggableLabel)
    }
    let tempLabels = draggedLabels
    tempLabels.push(draggableLabel)
    setDraggedLabels(tempLabels)
    setInPrice(false);
    setInQuality(false);
  };

  const onDragUpdate = (e) => {
    e.preventDefault()
    if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        priceRef.current
      )
    ) {
      setInPrice(true);
    } else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        qualityRef.current
      )
    ) {
      setInQuality(true);
    } else {
      setInPrice(false);
      setInQuality(false);
    }
  };

  const checkIfInAnyBox = (x, y, element) => {
    let targetX = element.offsetLeft;
    let targetY = element.offsetTop;
    let targetHeight = element.offsetHeight;
    let targetWidth = element.offsetWidth;
    // console.log(`x: ${x} >= targetX : ${targetX} and x: ${x} <= targetX + targetWidth: ${targetX + targetWidth} and y: ${y}  >= targetY: ${targetY} and y: ${y} < targetY + targetHeight: ${targetY + targetHeight}`)
    return (
      (x >= targetX &&
      x <= targetX + targetWidth &&
      y >= targetY &&
      y < targetY + targetHeight) ||
      (x >= targetX &&
        x <= targetX + (targetWidth)  &&
        y > targetY - (targetWidth/2) &&
        y < targetY + (targetWidth/2 + targetHeight)
        )
    );
  };

  function submitButtonAction() {
    if(submit){
      if(allCorrect){
        return allCorrect ? "Next" : "Try Again"
      }else{
        window.location.reload(false)
      }
    }else{
      setSubmit(true)
    }
  }

  return (
      <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "flex-start" }}>
              <h3 className={classes.heading}>Step 1. Drag and place the axis labels</h3>
              <div className={classes.labelContainer}>
                {!draggedLabels.includes("PRICE") &&
                  <DraggableLabel
                    image={PriceLabel}
                    onDragUpdate={onDragUpdate}
                    onDragStart={() => console.log("started")}
                    onDragEnd={onDragEnd}
                    setDraggableLabel={setDraggableLabel}
                    label={"PRICE"}
                  />
                }
                {!draggedLabels.includes("QUANTITY") &&
                  <DraggableLabel
                    image={QtyLabel}
                    onDragUpdate={onDragUpdate}
                    onDragStart={() => console.log("started")}
                    onDragEnd={onDragEnd}
                    left={"19%"}
                    setDraggableLabel={setDraggableLabel}
                    label={"QUANTITY"}
                  />
                }

                <DropableLabel
                  aref={priceRef}
                  inAnswer={inPrice}
                  isRight={true}
                  right={'48%'}
                  marginTop={isMobile ? 0 : -20}
                  rotate={"rotate(270deg)"}
                  label={xLabel}
                  isSubmitted={submit}
                  isCorrectLabel={xLabel==="PRICE"}
                />

                <DropableLabel
                  aref={qualityRef}
                  inAnswer={inQuality}
                  isRight={true}
                  right={isMobile ? "5%" : "20%"}
                  marginTop={isMobile ? 215 : 360}
                  rotate={"rotate(0deg)"}
                  label={yLabel}
                  isSubmitted={submit}
                  isCorrectLabel={yLabel==="QUANTITY"}
                />
              </div>
            </div>
           <div className={classes.tableContainer}>
            <h3 className={classes.questionText} >Step 2. Click to plot points and create a demand curve</h3>
            <table style={{ width: "100%", border: "1px solid white", borderCollapse: "collapse", backgroundColor: "#eeeeee" }}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th style={{ border: "1px solid white", width: "50%" }}><b>Oil Barrel Price</b></th>
                  <th style={{ border: "1px solid white"}}><b>Quantity Demanded <br/> (in millions of barrels)</b></th>
                </tr>
              </thead>
              <tbody style={{ border: "1px solid white" }}>
                {
                  correctAnswers.map((correctAnswer, index) => {
                    return(<tr key={index} className={classes.tableBody} style={{ backgroundColor: index%2 == 0 ? "#e1e1e1" : "#f0f0f0" }}>
                    <td style={{ border: "1px solid white" }}>${correctAnswer.y}</td>
                    <td style={{ border: "1px solid white" }}>{correctAnswer.x}</td>
                  </tr>)
                  })
                }
              </tbody>
            </table>

            {submit && 
            <div className={classes.answerContainer}>
              {(getLabeltext() || getAnswertext()) ?
              <>
                {getLabeltext() &&
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={crossIcon} alt="PriceLabel" className={classes.crossIcon}/>
                    <p className={classes.wrongText}>{getLabeltext()}</p> 
                  </div>
                }
                {getAnswertext() &&
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={crossIcon} alt="PriceLabel" className={classes.crossIcon}/>
                    <p className={classes.wrongText} dangerouslySetInnerHTML={{__html: getAnswertext()}}></p> 
                  </div>
                }
              </>
              : <img src={CorrectIcon} alt="CorrectIcon" className={classes.correctIcon} />
              }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
          {/* <p style={{ position: "absolute", color: "#003e4c", zIndex: 100, top: 36, paddingLeft: 3, fontFamily: "Rubik" }}>$</p> */}
          <CanvasJSChart options = {options} />
          {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: isMobile ? "73%" : "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
              {/* <p style={{ margin: "auto", color: "red", fontFamily: "Rubik", }}>Click "Try Again" button below</p> */}
            </div>
          }
          {/* <p style={{ position: "absolute", color: "#003e4c", right: 10, top: 358, fontFamily: "Rubik" }}>M</p> */}
          {submit &&
          answerCoordinates.map((coord) => {
            if(Object.keys(coord.style).length > 0){
              return <div style={coord.style}>{"("+coord.XYPoint.x + ", " + coord.XYPoint.y+")"}</div>
            }
          })
          }
          {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.retryButton} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.clearButton} onClick={() => window.location.reload(false)}>Clear</button>
              </>) : <button className={classes.submitButton} onClick={() => handleReloadClick()}>{getButtonText()}</button>
              // <img src={CorrectIcon} alt="CorrectIcon" style={{ height: 50, float: 'left', marginTop: '70px' }}/>
          }
        </div>
      </div>
    </>
  )

}

export default withStyles(styles)(BubbleAndLine);